module.exports = __webpack_public_path__ + "static/media/MASTER.a4bd3202.png";